import React, { useState, useEffect } from 'react';
import './InconsistencyWarning.css';

const InconsistencyWarning = () => {
    const [hasInconsistency, setHasInconsistency] = useState(false);

    useEffect(() => {
        const checkSync = async () => {
            try {
                const res = await fetch('/api/sync/status');
                if (res.ok) {
                    const data = await res.json();
                    // Só mostrar incoerência se a sincronização estiver ativada
                    setHasInconsistency(data.enabled && data.hasInconsistency);
                }
            } catch (err) {
                // Silently ignore
            }
        };

        checkSync();
        const interval = setInterval(checkSync, 300000); // Check every 5 mins
        return () => clearInterval(interval);
    }, []);

    if (!hasInconsistency) return null;

    return (
        <div className="sync-warning-bar">
            <span>⚠️ Atenção: Detectamos que os dados entre a unidade local e o host estão diferentes.</span>
            <a href="/settings" className="sync-link">Resolver Agora</a>
        </div>
    );
};

export default InconsistencyWarning;
